import { render, staticRenderFns } from "./ReagendarAtendimento.vue?vue&type=template&id=3ec18127"
import script from "./ReagendarAtendimento.vue?vue&type=script&lang=ts"
export * from "./ReagendarAtendimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports